import { CampaignControlOptionApiGroup } from '@/Enums/ControlOptions/CampaignGroup.enum';
import { Role } from '@/Enums/Users/Role.enum';
import { IAdvertiser, IPacingAdvertiser } from '@/Interfaces/Advertiser.interface';
import { IClientControlOption } from '@/Interfaces/ControlOption.interface';
import { IPacingFiltersApi } from '@/Interfaces/Pacing/Filters.interface';
import { RootState } from '@/store';
import { pacingClientsSelector, pacingWhitelabelsSelector } from '@/store/selectors/pacing.selectors';
import { getAdvertiserCampaignFilters } from '../filters/filterMapping';

export const getPacingFilters = (state: RootState, campaignGroup: CampaignControlOptionApiGroup): IPacingFiltersApi => {
  const {
    pacing: { filters },
    me: { role },
  } = state;

  const { clients } = pacingClientsSelector(state);
  const { whitelabels } = pacingWhitelabelsSelector(state);

  const { dateRangeStart, dateRangeEnd } = filters;
  const appliedFilter: IPacingFiltersApi = {
    dateRangeStart,
    dateRangeEnd,
  };

  const filterCampaigns = filters.campaigns?.filter(item => item.groupLabel === campaignGroup);

  const advertiserCampaignFilter = getAdvertiserCampaignFilters<IPacingAdvertiser, 'value'>(
    { ...filters, campaigns: filterCampaigns },
    role as unknown as Role,
    clients as IClientControlOption<IPacingAdvertiser>[],
    whitelabels,
    'value',
  );

  return {
    ...appliedFilter,
    ...advertiserCampaignFilter,
  };
};

export const pacingAdvertiserMapper = ({
  name,
  id,
  beeswaxAdvertiser,
  hasDv360Partner,
}: IAdvertiser): IPacingAdvertiser => ({
  label: name,
  beeswaxId: beeswaxAdvertiser?.beeswax_id,
  hasDv360Partner,
  value: id,
});

export const pacingAdvertiserFilter = ({ beeswaxAdvertiser, hasDv360Partner }: IAdvertiser): boolean =>
  !!(beeswaxAdvertiser?.beeswax_id || hasDv360Partner);
